import { FC, PropsWithChildren } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Link from '@/components/Link';
import FAQ from '@Landing/Systems/FAQ/FAQ';

import messages from './messages';

import useStyles from './styles';

const TeacherFAQ: FC<PropsWithChildren<unknown>> = () => {
  const { classes } = useStyles();
  const { formatMessage } = useIntl();

  const questions = [
    {
      iconText: '📚',
      description: messages.item1Description,
      question: messages.item1Title,
    },
    {
      iconText: '🎓',
      description: messages.item2Description,
      question: messages.item2Title,
    },
    {
      iconText: '📐',
      description: messages.item3Description,
      question: messages.item3Title,
    },
    {
      iconText: '🔎',
      description: messages.item4Description,
      question: messages.item4Title,
    },
    {
      iconText: '📝',
      description: messages.item5Description,
      question: messages.item5Title,
    },
  ];

  return (
    <FAQ
      questions={questions}
      bottomBannerProps={{
        link: '/sherpa/signup',
        title: <FormattedMessage {...messages.bottomBannerTitle} />,
        buttonText: formatMessage(messages.bottomBannerButton),
        caption: (
          <FormattedMessage
            {...messages.bottomBannerCaption}
            values={{
              link: (chunks) => (
                <Link
                  href="https://les-sherpas.zendesk.com/hc/fr/"
                  target="_blank"
                  className={classes.link}
                >
                  {chunks}
                </Link>
              ),
            }}
          />
        ),
      }}
    />
  );
};

export default TeacherFAQ;
